// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__66gn5","title":"styles_title__rWqEq"};